<div class="rij" (mouseenter)="hover.set(true)" (mouseleave)="hover.set(false)">
	<button type="button" class="open-knop" [attr.aria-label]="openLabel()" (click)="openGedeeldePaginaPersoonDialog(value())"></button>

	<div class="inhoud">
		<div class="titelrij">
			@if (isInbox() && value().ongelezen) {
				<app-icon name="unread" size="smallest" color="primary-1"></app-icon>
			}
			<span class="naam" [class.ongelezen]="isInbox() && value().ongelezen">{{ value().naam }}</span>
			<span class="datum" [class.verborgen]="meatballVisible()">{{ value().verzonden | date: "dd-MM-yyyy" }}</span>
			@if (isInbox()) {
				<app-meatball-menu (opened)="menuOpened.set($event)" size="L" [class.zichtbaar]="meatballVisible()">
					<app-meatball-menu-item icon="delete" (click)="delete(value())">Verwijderen</app-meatball-menu-item>
				</app-meatball-menu>
			}
		</div>
		<p class="bericht">{{ value().berichtWeergave }}</p>
		@if (value().hoofdpagina) {
			<span class="tag">{{ value().hoofdpagina }}</span>
		}
	</div>
</div>
